/** srcDoc 팝업(그리드·전체·순환) — 서버 AI 스냅샷 bbox (통합 관제 TRUST_SERVER_SNAPSHOT_OVERLAY 경로와 동일) */

export const MONITORING_POPUP_BBOX_LS_KEY = 'monitoringPopupShowBbox';

export function setMonitoringPopupShowBboxPref(enabled: boolean): void {
  if (typeof window === 'undefined') return;
  try {
    localStorage.setItem(MONITORING_POPUP_BBOX_LS_KEY, enabled ? '1' : '0');
  } catch {
    /* ignore */
  }
}

/** 통합 관제 AI 탐지 ON 시 팝업·그리드 검출 박스 기본 표시 */
export function applyCentralAiDetectShowBboxDefaults(): void {
  setMonitoringPopupShowBboxPref(true);
}

/** 시설 AI 탐지 ON/OFF에 맞춰 팝업 「검출 박스 표시」 초기값 동기화 */
export function syncMonitoringPopupShowBboxForAiDetect(aiDetectOn: boolean): void {
  setMonitoringPopupShowBboxPref(aiDetectOn);
}

export const MONITORING_POPUP_BBOX_CSS =
  '.cctv-pose-layer { position: absolute; left: 0; top: 0; width: 100%; height: 100%; pointer-events: none; z-index: 5; overflow: visible; }' +
  '.cctv-pose-layer svg { position: absolute; inset: 0; width: 100%; height: 100%; overflow: visible; }' +
  '.cctv-bbox-layer { position: absolute; left: 0; top: 0; width: 100%; height: 100%; pointer-events: none; z-index: 6; overflow: visible; }' +
  '.cctv-bbox-box { position: absolute; box-sizing: border-box; border-width: 2px; border-style: solid; }' +
  '.cctv-bbox-box-at-risk { border-width: 3px !important; border-color: #ff1744 !important; background-color: rgba(255, 23, 68, 0.18); box-shadow: 0 0 10px #ff1744; z-index: 2; }' +
  '.cctv-bbox-label { position: absolute; top: -20px; left: 0; max-width: 200%; font-size: 11px; line-height: 1.25; padding: 1px 4px; border-radius: 3px; white-space: nowrap; background: rgba(0,0,0,0.55); color: #eee; font-family: Arial, sans-serif; pointer-events: none; }' +
  '.cctv-bbox-label-risk { background: rgba(80, 0, 20, 0.88); color: #ff8a80; font-weight: bold; }' +
  '.popup-bbox-toggle { display: inline-flex; align-items: center; gap: 6px; color: #eee; font-size: 12px; cursor: pointer; user-select: none; margin-right: 4px; }' +
  '.popup-bbox-toggle input { cursor: pointer; }';

export function buildMonitoringPopupApiBootstrapScript(apiOrigin: string): string {
  const base = String(apiOrigin || '').replace(/\/+$/, '');
  return (
    '<script>window.__MONITORING_POPUP_API_BASE__=' +
    JSON.stringify(base) +
    ';</script>'
  );
}

export const MONITORING_POPUP_BBOX_SCRIPT =
  '(function() {' +
  'var LS_KEY = ' +
  JSON.stringify(MONITORING_POPUP_BBOX_LS_KEY) +
  ';' +
  'var snapshotMap = {};' +
  'var showBbox = false;' +
  'var rotationTarget = null;' +
  'var RISK_BORDER = "#ff1744";' +
  'function readBboxPref() {' +
  '  try {' +
  '    var v = localStorage.getItem(LS_KEY);' +
  '    showBbox = v === "1" || v === "true";' +
  '  } catch (e) { showBbox = false; }' +
  '  var cb = document.getElementById("popup-bbox-toggle");' +
  '  if (cb) cb.checked = showBbox;' +
  '}' +
  'function saveBboxPref(on) {' +
  '  try { localStorage.setItem(LS_KEY, on ? "1" : "0"); } catch (e) {}' +
  '}' +
  'function authHeaders() {' +
  '  var t = null;' +
  '  try { t = localStorage.getItem("token") || localStorage.getItem("auth_token"); } catch (e) {}' +
  '  return t ? { Authorization: "Bearer " + t } : {};' +
  '}' +
  'function bboxColor(cls) {' +
  '  cls = (cls || "").toLowerCase();' +
  '  if (cls === "swimmer") return "#00ff00";' +
  '  if (cls === "drowning") return "#ff0000";' +
  '  if (cls === "lifeguard") return "#00b0ff";' +
  '  if (cls === "person") return "#ffeb3b";' +
  '  return "#ff5252";' +
  '}' +
  'function snapFromRow(row) {' +
  '  return {' +
  '    detections: row.detections || [],' +
  '    risk_alerts: row.risk_alerts || [],' +
  '    frame_width: row.frame_width,' +
  '    frame_height: row.frame_height,' +
  '    openpose_overlay: row.openpose_overlay || null' +
  '  };' +
  '}' +
  'function riskMetaByTrackId(snap) {' +
  '  var map = {};' +
  '  if (!snap || !snap.risk_alerts) return map;' +
  '  var alerts = snap.risk_alerts;' +
  '  for (var i = 0; i < alerts.length; i++) {' +
  '    var a = alerts[i];' +
  '    if (!a) continue;' +
  '    var rt = String(a.risk_type || "").toLowerCase();' +
  '    var match = rt === "drowning" || rt === "no_motion" || rt === "sinking" || rt === "openpose_pose" || a.risk_type === "drowning_risk" || a.risk_type === "motion_risk";' +
  '    if (!match) continue;' +
  '    var level = String(a.risk_level || "").trim();' +
  '    if (level !== "위험" && level !== "주의" && level !== "medium" && level !== "high") continue;' +
  '    var tid = Number(a.track_id != null ? a.track_id : a.object_id);' +
  '    if (!Number.isFinite(tid)) continue;' +
  '    map[tid] = { level: level, label: String(a.risk_label || "").trim() || String(a.risk_type || "").trim() || "위험" };' +
  '  }' +
  '  return map;' +
  '}' +
  'var POSE_PAIRS = [["Neck","RShoulder"],["Neck","LShoulder"],["RShoulder","RElbow"],["RElbow","RWrist"],["LShoulder","LElbow"],["LElbow","LWrist"],["Neck","RHip"],["RHip","RKnee"],["RKnee","RAnkle"],["Neck","LHip"],["LHip","LKnee"],["LKnee","LAnkle"],["Neck","Nose"],["Nose","REye"],["REye","REar"],["Nose","LEye"],["LEye","LEar"]];' +
  'function mapRectToContainPct(x1,y1,x2,y2,sw,sh,cw,ch) {' +
  '  sw = Math.max(1, sw); sh = Math.max(1, sh); cw = Math.max(1, cw); ch = Math.max(1, ch);' +
  '  var scale = Math.min(cw / sw, ch / sh);' +
  '  var dispW = sw * scale; var dispH = sh * scale;' +
  '  var offX = (cw - dispW) / 2; var offY = (ch - dispH) / 2;' +
  '  var loX = Math.min(x1, x2); var hiX = Math.max(x1, x2);' +
  '  var loY = Math.min(y1, y2); var hiY = Math.max(y1, y2);' +
  '  return {' +
  '    left: ((offX + (loX / sw) * dispW) / cw) * 100,' +
  '    top: ((offY + (loY / sh) * dispH) / ch) * 100,' +
  '    width: (((hiX - loX) / sw) * dispW / cw) * 100,' +
  '    height: (((hiY - loY) / sh) * dispH / ch) * 100' +
  '  };' +
  '}' +
  'function layerSize(layer) {' +
  '  if (!layer) return { w: 0, h: 0 };' +
  '  var w = layer.clientWidth || layer.offsetWidth || 0;' +
  '  var h = layer.clientHeight || layer.offsetHeight || 0;' +
  '  return { w: w, h: h };' +
  '}' +
  'function videoInLayer(layer) {' +
  '  if (!layer || !layer.parentElement) return null;' +
  '  return layer.parentElement.querySelector("video");' +
  '}' +
  'function renderPose(layer, snap) {' +
  '  if (!layer) return;' +
  '  layer.innerHTML = "";' +
  '  if (!showBbox || !snap || !snap.openpose_overlay || !snap.openpose_overlay.persons) return;' +
  '  var fw = Math.max(1, Number(snap.frame_width) || 0);' +
  '  var fh = Math.max(1, Number(snap.frame_height) || 0);' +
  '  var vid = videoInLayer(layer);' +
  '  if ((!fw || !fh) && vid) { fw = Math.max(1, vid.videoWidth || fw || 1280); fh = Math.max(1, vid.videoHeight || fh || 720); }' +
  '  if (!fw) fw = 1280; if (!fh) fh = 720;' +
  '  var sz = layerSize(layer);' +
  '  var svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");' +
  '  svg.setAttribute("viewBox", "0 0 100 100");' +
  '  svg.setAttribute("preserveAspectRatio", "none");' +
  '  snap.openpose_overlay.persons.forEach(function(person) {' +
  '    var by = {};' +
  '    (person.kps || []).forEach(function(kp) {' +
  '      if (!kp || !kp.p) return;' +
  '      var px = Number(kp.x); var py = Number(kp.y);' +
  '      if (sz.w > 0 && sz.h > 0) {' +
  '        var mapped = mapRectToContainPct(px, py, px, py, fw, fh, sz.w, sz.h);' +
  '        by[kp.p] = { x: mapped.left, y: mapped.top };' +
  '      } else {' +
  '        by[kp.p] = { x: (px / fw) * 100, y: (py / fh) * 100 };' +
  '      }' +
  '    });' +
  '    var stroke = person.unusual ? "rgba(255,80,120,0.95)" : "rgba(0,255,200,0.85)";' +
  '    POSE_PAIRS.forEach(function(pair) {' +
  '      var a = by[pair[0]]; var b = by[pair[1]];' +
  '      if (!a || !b) return;' +
  '      var line = document.createElementNS("http://www.w3.org/2000/svg", "line");' +
  '      line.setAttribute("x1", String(a.x)); line.setAttribute("y1", String(a.y));' +
  '      line.setAttribute("x2", String(b.x)); line.setAttribute("y2", String(b.y));' +
  '      line.setAttribute("stroke", stroke); line.setAttribute("stroke-width", person.unusual ? "0.35" : "0.25");' +
  '      svg.appendChild(line);' +
  '    });' +
  '  });' +
  '  layer.appendChild(svg);' +
  '}' +
  'function renderBoxes(layer, snap) {' +
  '  if (!layer) return;' +
  '  layer.innerHTML = "";' +
  '  if (!showBbox || !snap) return;' +
  '  var fw = Math.max(1, Number(snap.frame_width) || 0);' +
  '  var fh = Math.max(1, Number(snap.frame_height) || 0);' +
  '  var vid = videoInLayer(layer);' +
  '  if ((!fw || !fh) && vid) { fw = Math.max(1, vid.videoWidth || 0); fh = Math.max(1, vid.videoHeight || 0); }' +
  '  if (!fw) fw = 1280; if (!fh) fh = 720;' +
  '  var sz = layerSize(layer);' +
  '  var dets = snap.detections || [];' +
  '  var riskByTrack = riskMetaByTrackId(snap);' +
  '  for (var i = 0; i < dets.length; i++) {' +
  '    var det = dets[i];' +
  '    if (!det || !det.bbox || det.bbox.length !== 4) continue;' +
  '    var b = det.bbox.map(Number);' +
  '    var detFw = Math.max(1, Number(det.frame_width) || fw);' +
  '    var detFh = Math.max(1, Number(det.frame_height) || fh);' +
  '    var maxC = Math.max(Math.abs(b[0]), Math.abs(b[1]), Math.abs(b[2]), Math.abs(b[3]));' +
  '    if (maxC > 0 && maxC <= 1.5) {' +
  '      b = [b[0]*detFw, b[1]*detFh, b[2]*detFw, b[3]*detFh];' +
  '    } else if (detFw !== fw || detFh !== fh) {' +
  '      var maxX = Math.max(Math.abs(b[0]), Math.abs(b[2]));' +
  '      var maxY = Math.max(Math.abs(b[1]), Math.abs(b[3]));' +
  '      if (maxX <= detFw * 1.08 + 2 && maxY <= detFh * 1.08 + 2) {' +
  '        b = [b[0]*fw/detFw, b[1]*fh/detFh, b[2]*fw/detFw, b[3]*fh/detFh];' +
  '      }' +
  '    }' +
  '    var x1 = Math.min(b[0], b[2]); var x2 = Math.max(b[0], b[2]);' +
  '    var y1 = Math.min(b[1], b[3]); var y2 = Math.max(b[1], b[3]);' +
  '    var tid = Number(det.track_id != null ? det.track_id : det.id);' +
  '    if (!Number.isFinite(tid) || tid <= 0) tid = i + 1;' +
  '    var riskMeta = riskByTrack[tid];' +
  '    var atRisk = !!riskMeta;' +
  '    var el = document.createElement("div");' +
  '    el.className = "cctv-bbox-box" + (atRisk ? " cctv-bbox-box-at-risk" : "");' +
  '    if (sz.w > 0 && sz.h > 0) {' +
  '      var pct = mapRectToContainPct(x1, y1, x2, y2, fw, fh, sz.w, sz.h);' +
  '      el.style.left = pct.left + "%";' +
  '      el.style.top = pct.top + "%";' +
  '      el.style.width = pct.width + "%";' +
  '      el.style.height = pct.height + "%";' +
  '    } else {' +
  '      el.style.left = (x1 / fw * 100) + "%";' +
  '      el.style.top = (y1 / fh * 100) + "%";' +
  '      el.style.width = ((x2 - x1) / fw * 100) + "%";' +
  '      el.style.height = ((y2 - y1) / fh * 100) + "%";' +
  '    }' +
  '    if (!atRisk) el.style.borderColor = bboxColor(det.class_name);' +
  '    var cls = String(det.class_name || "person");' +
  '    var sc = Number(det.score != null ? det.score : det.confidence);' +
  '    if (!Number.isFinite(sc)) sc = 0;' +
  '    var label = document.createElement("span");' +
  '    label.className = "cctv-bbox-label" + (atRisk ? " cctv-bbox-label-risk" : "");' +
  '    var labelText = "";' +
  '    if (atRisk) labelText += "위험 · " + (riskMeta.label || "위험") + " · " + (riskMeta.level || "주의") + " · ";' +
  '    labelText += cls + " " + Math.round(Math.min(1, Math.max(0, sc)) * 100) + "%";' +
  '    label.textContent = labelText;' +
  '    el.appendChild(label);' +
  '    layer.appendChild(el);' +
  '  }' +
  '}' +
  'function renderGridCells() {' +
  '  document.querySelectorAll(".cctv-cell[data-cctv-id]").forEach(function(cell) {' +
  '    var pid = cell.getAttribute("data-pool-id");' +
  '    var cid = cell.getAttribute("data-cctv-id");' +
  '    if (!pid || !cid) return;' +
  '    var bboxLayer = cell.querySelector(".cctv-bbox-layer");' +
  '    var poseLayer = cell.querySelector(".cctv-pose-layer");' +
  '    var key = pid + ":" + cid;' +
  '    var snap = snapshotMap[key];' +
  '    renderPose(poseLayer, snap);' +
  '    renderBoxes(bboxLayer, snap);' +
  '  });' +
  '}' +
  'function renderRotation() {' +
  '  var bboxLayer = document.getElementById("rot-bbox-layer");' +
  '  var poseLayer = document.getElementById("rot-pose-layer");' +
  '  if (!rotationTarget) {' +
  '    if (bboxLayer) bboxLayer.innerHTML = "";' +
  '    if (poseLayer) poseLayer.innerHTML = "";' +
  '    return;' +
  '  }' +
  '  var key = rotationTarget.poolId + ":" + rotationTarget.cctvId;' +
  '  var snap = snapshotMap[key];' +
  '  renderPose(poseLayer, snap);' +
  '  renderBoxes(bboxLayer, snap);' +
  '}' +
  'function applySnapshots(rows) {' +
  '  snapshotMap = {};' +
  '  if (!Array.isArray(rows)) return;' +
  '  rows.forEach(function(row) {' +
  '    var pid = Number(row.pool_id); var cid = Number(row.cctv_id);' +
  '    if (!Number.isFinite(pid) || !Number.isFinite(cid)) return;' +
  '    snapshotMap[String(pid) + ":" + String(cid)] = snapFromRow(row);' +
  '  });' +
  '  renderGridCells();' +
  '  renderRotation();' +
  '  emitRiskEventsFromRows(rows);' +
  '}' +
  'var riskEmitCooldown = {};' +
  'function capturePopupVideoFrame(cctvId) {' +
  '  try {' +
  '    var video = document.getElementById("cctv-" + cctvId);' +
  '    if (!video || video.readyState < 2) return "";' +
  '    var w = video.videoWidth; var h = video.videoHeight;' +
  '    if (!w || !h) return "";' +
  '    var canvas = document.createElement("canvas");' +
  '    canvas.width = w; canvas.height = h;' +
  '    var ctx = canvas.getContext("2d");' +
  '    if (!ctx) return "";' +
  '    ctx.drawImage(video, 0, 0, w, h);' +
  '    return canvas.toDataURL("image/jpeg", 0.82);' +
  '  } catch (eCap) { return ""; }' +
  '}' +
  'function emitRiskEventsFromRows(rows) {' +
  '  if (!Array.isArray(rows)) return;' +
  '  var now = Date.now();' +
  '  for (var i = 0; i < rows.length; i++) {' +
  '    var row = rows[i];' +
  '    if (!row || !Array.isArray(row.risk_alerts) || !row.risk_alerts.length) continue;' +
  '    var pid = Number(row.pool_id); var cid = Number(row.cctv_id);' +
  '    if (!Number.isFinite(pid) || !Number.isFinite(cid)) continue;' +
  '    var alert = null;' +
  '    for (var j = 0; j < row.risk_alerts.length; j++) {' +
  '      var a = row.risk_alerts[j];' +
  '      if (!a) continue;' +
  '      var rt = String(a.risk_type || "").toLowerCase();' +
  '      if (rt === "drowning" || rt === "no_motion" || rt === "sinking" || rt === "openpose_pose" || a.risk_type === "drowning_risk" || a.risk_type === "motion_risk") { alert = a; break; }' +
  '    }' +
  '    if (!alert) continue;' +
  '    var key = pid + ":" + cid + ":" + String(alert.risk_type || "");' +
  '    if (riskEmitCooldown[key] && now - riskEmitCooldown[key] < 8000) continue;' +
  '    riskEmitCooldown[key] = now;' +
  '    var poolName = "";' +
  '    try {' +
  '      var sec = document.querySelector(".pool-section[data-pool-id=\\"" + pid + "\\"] .pool-header");' +
  '      if (sec) poolName = String(sec.textContent || "").trim();' +
  '    } catch (eN) {}' +
  '    var imageDataUrl = capturePopupVideoFrame(cid);' +
  '    var bboxes = [];' +
  '    try {' +
  '      var snap = snapFromRow(row);' +
  '      var dets = (snap && snap.detections) ? snap.detections : (row.detections || []);' +
  '      var riskTid = {};' +
  '      for (var rj = 0; rj < row.risk_alerts.length; rj++) {' +
  '        var ra = row.risk_alerts[rj]; if (!ra) continue;' +
  '        var rtid = Number(ra.track_id != null ? ra.track_id : ra.object_id);' +
  '        if (Number.isFinite(rtid)) riskTid[rtid] = ra;' +
  '      }' +
  '      if (Array.isArray(dets)) {' +
  '        for (var di = 0; di < dets.length; di++) {' +
  '          var det = dets[di];' +
  '          if (!det || !det.bbox || det.bbox.length !== 4) continue;' +
  '          var tid = Number(det.track_id != null ? det.track_id : det.id);' +
  '          var risk = Number.isFinite(tid) ? riskTid[tid] : null;' +
  '          var atRisk = !!risk;' +
  '          if (!atRisk && Object.keys(riskTid).length > 0) continue;' +
  '          bboxes.push({' +
  '            bbox: det.bbox.map(Number),' +
  '            frame_width: det.frame_width,' +
  '            frame_height: det.frame_height,' +
  '            trackId: Number.isFinite(tid) ? tid : di,' +
  '            motionRisk: atRisk,' +
  '            riskSubtypeLabel: risk && risk.risk_label ? risk.risk_label : "",' +
  '            class_name: det.class_name || "person"' +
  '          });' +
  '        }' +
  '      }' +
  '    } catch (eB) {}' +
  '    try {' +
  '      window.parent.postMessage({' +
  '        type: "monitoring-popup-risk-event",' +
  '        poolId: pid,' +
  '        cctvId: cid,' +
  '        poolName: poolName,' +
  '        riskType: alert.risk_type || "drowning",' +
  '        riskLabel: alert.risk_label || "",' +
  '        riskLevel: alert.risk_level || "",' +
  '        message: alert.message || "",' +
  '        imageDataUrl: imageDataUrl || "",' +
  '        bboxes: bboxes' +
  '      }, "*");' +
  '    } catch (eP) {}' +
  '  }' +
  '}' +
  'function hasAuthToken() {' +
  '  try { return !!(localStorage.getItem("token") || localStorage.getItem("auth_token")); } catch (e) { return false; }' +
  '}' +
  'function snapshotsFromParent() {' +
  '  try { return !!(window.parent && window.parent !== window); } catch (e) { return false; }' +
  '}' +
  'var snapshotPollTimer = null;' +
  'var snapshotPollStopped = false;' +
  'function stopSnapshotPoll() {' +
  '  snapshotPollStopped = true;' +
  '  if (snapshotPollTimer) { clearInterval(snapshotPollTimer); snapshotPollTimer = null; }' +
  '}' +
  'function clearSnapshotPollTimer() {' +
  '  if (snapshotPollTimer) { clearInterval(snapshotPollTimer); snapshotPollTimer = null; }' +
  '}' +
  'function startSnapshotPoll() {' +
  '  if (snapshotPollStopped || snapshotsFromParent() || !hasAuthToken()) return;' +
  '  if (!showBbox) return;' +
  '  if (snapshotPollTimer) return;' +
  '  pollSnapshots();' +
  '  snapshotPollTimer = setInterval(pollSnapshots, 1000);' +
  '}' +
  'function notifyBboxPref(on) {' +
  '  try { window.parent.postMessage({ type: "monitoring-popup-bbox-pref", on: !!on }, "*"); } catch (e) {}' +
  '}' +
  'function pollSnapshots() {' +
  '  if (snapshotPollStopped || snapshotsFromParent() || !showBbox) return;' +
  '  if (!hasAuthToken()) return;' +
  '  var base = (window.__MONITORING_POPUP_API_BASE__ || window.location.origin || "").replace(/\\/$/, "");' +
  '  if (!base) return;' +
  '  fetch(base + "/api/central-ai-monitor/snapshots", { headers: authHeaders(), credentials: "include" })' +
  '    .then(function(r) {' +
  '      if (r.status === 401) { stopSnapshotPoll(); return null; }' +
  '      if (!r.ok) throw new Error(String(r.status));' +
  '      return r.json();' +
  '    })' +
  '    .then(function(data) { if (data && showBbox) applySnapshots(data); })' +
  '    .catch(function() {});' +
  '}' +
  'window.addEventListener("message", function(ev) {' +
  '  if (!ev.data || ev.data.type !== "monitoring-popup-snapshots") return;' +
  '  if (!showBbox) return;' +
  '  applySnapshots(ev.data.rows);' +
  '});' +
  'window.__popupBboxSetRotationTarget = function(poolId, cctvId) {' +
  '  if (poolId == null || cctvId == null) { rotationTarget = null; renderRotation(); return; }' +
  '  rotationTarget = { poolId: String(poolId), cctvId: String(cctvId) };' +
  '  renderRotation();' +
  '};' +
  'function initBboxUi() {' +
  '  readBboxPref();' +
  '  var cb = document.getElementById("popup-bbox-toggle");' +
  '  if (cb) {' +
  '    cb.addEventListener("change", function() {' +
  '      showBbox = !!cb.checked;' +
  '      saveBboxPref(showBbox);' +
  '      notifyBboxPref(showBbox);' +
  '      if (showBbox) {' +
  '        snapshotPollStopped = false;' +
  '        startSnapshotPoll();' +
  '        try {' +
  '          var baseP = (window.__MONITORING_POPUP_API_BASE__ || "").replace(/\\/$/, "");' +
  '          if (baseP && hasAuthToken()) {' +
  '            fetch(baseP + "/api/central-ai-monitor/presence", { method: "POST", headers: Object.assign({ "Content-Type": "application/json" }, authHeaders()), credentials: "include", body: "{}" }).catch(function() {});' +
  '          }' +
  '        } catch (ePres) {}' +
  '      } else {' +
  '        clearSnapshotPollTimer();' +
  '        snapshotMap = {};' +
  '      }' +
  '      renderGridCells();' +
  '      renderRotation();' +
  '    });' +
  '  }' +
  '  notifyBboxPref(showBbox);' +
  '  if (showBbox) startSnapshotPoll();' +
  '}' +
  'if (document.readyState === "loading") {' +
  '  document.addEventListener("DOMContentLoaded", initBboxUi);' +
  '} else {' +
  '  initBboxUi();' +
  '}' +
  '})();';

export function buildPopupBboxToolbarHtml(): string {
  return (
    '<label class="popup-bbox-toggle" title="켜면 서버 AI 검출 박스를 표시하고, 이때만 스냅샷을 자주 조회 (기본 OFF)">' +
    '<input type="checkbox" id="popup-bbox-toggle" />' +
    '검출 박스 표시</label>'
  );
}

/** 전체 모니터링(/all/cctv) 시설별 AI 탐지 ON/OFF */
export const MONITORING_POPUP_POOL_AI_SCRIPT =
  '(function() {' +
  'function apiBase() {' +
  '  var b = window.__MONITORING_POPUP_API_BASE__ || "";' +
  '  return String(b).replace(/\\/+$/, "");' +
  '}' +
  'function authHeaders() {' +
  '  var t = null;' +
  '  try { t = localStorage.getItem("token") || localStorage.getItem("auth_token"); } catch (e) {}' +
  '  var h = { "Content-Type": "application/json" };' +
  '  if (t) h.Authorization = "Bearer " + t;' +
  '  return h;' +
  '}' +
  'function setBboxOn(on) {' +
  '  try { localStorage.setItem(' +
  JSON.stringify(MONITORING_POPUP_BBOX_LS_KEY) +
  ', on ? "1" : "0"); } catch (e) {}' +
  '  var cb = document.getElementById("popup-bbox-toggle");' +
  '  if (cb) {' +
  '    cb.checked = !!on;' +
  '    try { cb.dispatchEvent(new Event("change")); } catch (e2) {}' +
  '  }' +
  '}' +
  'function applyIncluded(ids) {' +
  '  var set = {};' +
  '  (ids || []).forEach(function(id) { set[String(id)] = true; });' +
  '  document.querySelectorAll("input.pool-ai-detect[data-pool-id]").forEach(function(el) {' +
  '    el.checked = !!set[String(el.getAttribute("data-pool-id"))];' +
  '  });' +
  '}' +
  'function refreshStatus() {' +
  '  var base = apiBase();' +
  '  if (!base) return;' +
  '  fetch(base + "/api/central-ai-monitor/status", { headers: authHeaders(), credentials: "include" })' +
  '    .then(function(r) { return r.ok ? r.json() : null; })' +
  '    .then(function(data) {' +
  '      if (!data) return;' +
  '      var optIn = data.central_monitor_opt_in !== false;' +
  '      if (optIn) applyIncluded(data.included_pool_ids || []);' +
  '      else {' +
  '        var ex = {};' +
  '        (data.excluded_pool_ids || []).forEach(function(id) { ex[String(id)] = true; });' +
  '        document.querySelectorAll("input.pool-ai-detect[data-pool-id]").forEach(function(el) {' +
  '          el.checked = !ex[String(el.getAttribute("data-pool-id"))];' +
  '        });' +
  '      }' +
  '    }).catch(function() {});' +
  '}' +
  'function togglePool(poolId, turnOn, checkbox) {' +
  '  var base = apiBase();' +
  '  if (!base) { checkbox.checked = !turnOn; return; }' +
  '  var url = base + "/api/central-ai-monitor/exclude-pool/" + poolId;' +
  '  var opts = { headers: authHeaders(), credentials: "include" };' +
  '  opts.method = turnOn ? "DELETE" : "POST";' +
  '  if (!turnOn) opts.body = "{}";' +
  '  checkbox.disabled = true;' +
  '  fetch(url, opts).then(function(r) {' +
  '    if (!r.ok) throw new Error(String(r.status));' +
  '    return r.json().catch(function() { return {}; });' +
  '  }).then(function(data) {' +
  '    if (data && Array.isArray(data.included_pool_ids)) applyIncluded(data.included_pool_ids);' +
  '    else checkbox.checked = turnOn;' +
  '    if (turnOn) {' +
  '      setBboxOn(true);' +
  '      fetch(base + "/api/central-ai-monitor/presence", { method: "POST", headers: authHeaders(), credentials: "include", body: "{}" }).catch(function() {});' +
  '    }' +
  '    try { window.parent.postMessage({ type: "monitoring-popup-ai-toggled", poolId: poolId, on: turnOn }, "*"); } catch (e) {}' +
  '  }).catch(function() {' +
  '    checkbox.checked = !turnOn;' +
  '    alert("AI 탐지 설정에 실패. 로그인·네트워크를 확인.");' +
  '  }).finally(function() { checkbox.disabled = false; });' +
  '}' +
  'function initPoolAi() {' +
  '  refreshStatus();' +
  '  document.querySelectorAll("input.pool-ai-detect[data-pool-id]").forEach(function(el) {' +
  '    el.addEventListener("change", function() {' +
  '      var pid = Number(el.getAttribute("data-pool-id"));' +
  '      if (!Number.isFinite(pid)) return;' +
  '      togglePool(pid, !!el.checked, el);' +
  '    });' +
  '  });' +
  '}' +
  'if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", initPoolAi);' +
  'else initPoolAi();' +
  '})();';
